import styled from 'styled-components';
export const Cell = styled.div `
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  line-height: 24px;
  padding: 8px 16px 8px 16px;
  height: 40px;
  box-sizing: border-box;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
  position: relative;
`;
//# sourceMappingURL=Cell.js.map